export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_2.c00dcdd6.webp";